import { TopicRes } from "@/models/topics.model"
import { PHAClient } from "@/utils/axios"

export const getTopic = async (): Promise<TopicRes> => {
  const response = await PHAClient.get(`/api/topic/all`)
  return response.data
}